import { FunctionComponent, PropsWithChildren } from 'react';
import { styled } from '@mui/material/styles';

const StyledRoot = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
});

const Main = styled('div')(() => ({
  flexGrow: 1,
  minHeight: '100%',
  overflow: 'auto',
}));

export const SimpleLayout: FunctionComponent<PropsWithChildren> = (props) => {
  const { children } = props;
  return (
    <StyledRoot>
      <Main>{children}</Main>
    </StyledRoot>
  );
};
